export const API = {
  SHORTLISTS: {
    SINGLE: "/users/me/shortlists/:id",
  },
};
